import Model, { attr } from '@ember-data/model';
import { computed, get } from '@ember/object';

export default Model.extend({
  employeeName: attr('string'),
  payCycle: attr('string'),
  endAt: attr('date-only'),
  checkNumber: attr('number'),
  benefits: attr(),
  deductions: attr(),
  hours: attr(),
  summaries: attr(),

  grossWages: computed(function () {
    let summaries = this.summaries || [];
    let grossWageSummary = summaries.find(
      (x) => x['description'] === 'Gross Wages',
    );
    if (grossWageSummary) {
      return get(grossWageSummary, 'amount');
    } else {
      return 0;
    }
  }),

  netPay: computed(function () {
    let summaries = this.summaries || [];
    let netPaySummary = summaries.find((x) => x['description'] === 'Net Pay');
    if (netPaySummary) {
      return get(netPaySummary, 'amount');
    } else {
      return 0;
    }
  }),
});
